import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  container: {
    [theme.breakpoints.up('lg')]: {
      paddingLeft: theme.spacing(8),
      paddingRight: theme.spacing(8),
    },
  },
  flexWrap: {
    flexWrap: 'wrap',
  },
  active: {
    backgroundColor: theme.palette.success.main,
    color: theme.palette.common.white,
  },
  inactive: {
    backgroundColor: theme.palette.error.main,
    color: theme.palette.common.white,
  },
  truncatedText: {
    display: 'block',
    maxWidth: '58ch',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
}))

export default useStyles
